/* Optima Store – oferte automate aparat de sigilat doze (adăugare/scoatere automată cadou în coș).
   Prețurile (gratuit / -50%) sunt aplicate de reducerile automate Shopify; scriptul doar pune/scoate produsele cadou. */
(function () {
  'use strict';

  var PACK_VARIANTS = [48785052631209, 48785052663977, 48785052696745, 48785052729513, 48785052762281]; // doze PET, baxuri de 200 buc
  var MACHINE_VARIANT = 46571821793449; // Aparat de sigilat doze
  var GIFT_DOZE_VARIANT = 51492670406825; // CADOU: 600 doze PET 330 ml
  var FREE_MACHINE_AT = 50; // 50 baxuri = 10.000 doze -> aparat gratuit
  var HALF_MACHINE_AT = 25; // 25 baxuri = 5.000 doze -> aparat -50%
  var GIFT_ATTR = '_optima_aparat_auto';
  var DECLINED_ATTR = '_optima_aparat_refuzat';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var running = false;
  var queued = false;

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(String(url || ''));
  }

  function request(path, body) {
    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    opts.optimaGift = true;
    return fetch(root + path, opts).then(function (r) { return r.json(); });
  }

  function refreshCartUi() {
    if (/\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  async function sync() {
    if (running) { queued = true; return; }
    running = true;
    try {
      var cart = await request('cart.js');
      var packs = 0;
      var machineLines = [];
      var dozeGiftLines = [];
      var machineQty = 0;
      var dozeGiftQty = 0;

      cart.items.forEach(function (line) {
        if (PACK_VARIANTS.indexOf(line.variant_id) !== -1) packs += line.quantity;
        if (line.variant_id === MACHINE_VARIANT) { machineLines.push(line); machineQty += line.quantity; }
        if (line.variant_id === GIFT_DOZE_VARIANT) { dozeGiftLines.push(line); dozeGiftQty += line.quantity; }
      });

      // În atributele coșului ținem minte dacă aparatul a fost pus automat (și la ce nivel: half/free)
      // și dacă clientul l-a scos singur (ca să nu-l punem înapoi la același nivel).
      var attrsNow = cart.attributes || {};
      var flag = attrsNow[GIFT_ATTR] || '';
      var declined = attrsNow[DECLINED_ATTR] || '';
      var tier = packs >= FREE_MACHINE_AT ? 'free' : (packs >= HALF_MACHINE_AT ? 'half' : '');

      if (flag && machineQty === 0) { declined = flag; flag = ''; } // clientul a scos aparatul

      var targetMachine = machineQty;
      if (!tier) {
        // Sub 25 de baxuri: scoatem aparatul pus automat.
        if (flag) { targetMachine = machineQty - 1; flag = ''; }
        declined = '';
      } else if (flag) {
        flag = tier;
      } else if (machineQty === 0 && (!declined || (declined === 'half' && tier === 'free'))) {
        // 25-49 baxuri: aparat la -50%; 50+ baxuri: aparat gratuit. Prețul îl aplică reducerile automate.
        targetMachine = 1;
        flag = tier;
      }
      var machinePaid = targetMachine - (flag ? 1 : 0);

      // 600 doze gratuite: doar la aparat cumpărat separat (sub 25 baxuri).
      var targetDoze = tier ? 0 : machinePaid;

      var updates = {};
      var adds = [];
      var changed = false;

      function setTotal(lines, current, target, variantId) {
        if (current === target) return;
        changed = true;
        if (!lines.length) { adds.push({ id: variantId, quantity: target }); return; }
        lines.forEach(function (line, index) { updates[line.key] = index === 0 ? target : 0; });
      }

      setTotal(machineLines, machineQty, targetMachine, MACHINE_VARIANT);
      setTotal(dozeGiftLines, dozeGiftQty, targetDoze, GIFT_DOZE_VARIANT);

      var attrs = {};
      attrs[GIFT_ATTR] = flag;
      attrs[DECLINED_ATTR] = declined;
      var attrsChanged = flag !== (attrsNow[GIFT_ATTR] || '') || declined !== (attrsNow[DECLINED_ATTR] || '');

      if (Object.keys(updates).length || attrsChanged) {
        await request('cart/update.js', { updates: updates, attributes: attrs });
      }
      if (adds.length) {
        await request('cart/add.js', { items: adds });
      }
      if (changed) refreshCartUi();
    } catch (err) {
      if (window.console) console.warn('Optima gift offers:', err);
    } finally {
      running = false;
      if (queued) { queued = false; setTimeout(sync, 200); }
    }
  }

  function scheduleSync() { setTimeout(sync, 400); }

  // Urmărește modificările de coș făcute de temă sau de alte aplicații.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var mine = !!(init && init.optimaGift);
    var promise = nativeFetch.apply(this, arguments);
    if (!mine && isCartMutation(url)) promise.then(scheduleSync, scheduleSync);
    return promise;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) this.addEventListener('loadend', scheduleSync);
    return nativeOpen.apply(this, arguments);
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.action && isCartMutation(form.action)) scheduleSync();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();

/* Optima Store - afiseaza pretul fara TVA si cu TVA si pe cardurile rescrise de aplicatia Variants on Collection (sezerium). */
(function () {
  'use strict';

  var VAT = 1.21;
  var PLAIN = /^\s*([\d.\s]+(?:,\d{1,2})?)\s*lei\s*$/i;

  function parseRo(text) {
    var m = PLAIN.exec(text || '');
    if (!m) return null;
    var n = parseFloat(m[1].replace(/[.\s]/g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function fmt(n) {
    return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  }

  function render(el) {
    if (el.querySelector('.actual_price')) return;
    var net = parseRo(el.textContent);
    if (net === null) return;
    var gross = Math.round(net * VAT * 100) / 100;
    el.innerHTML = '<p class="actual_price">' + fmt(net) + ' <span>(fără TVA)</span></p>' +
      '<div class="mainipulated_price"><p class="price_div">' + fmt(gross) + ' <span> (cu TVA)</span></p></div>';
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('product-card .sezerium-price, product-card s.price__was');
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(document); }, 30);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
